import { Box as MuiBox } from "@mui/material";
import React from "react";

export default function Box({ children, ...rest }) {
  return <MuiBox {...rest}>{children}</MuiBox>;
}
